import * as React from 'react';
import { Search, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface SearchBarProps {
  onChange: (value: string) => void;
  value: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function SearchBar({ onChange, value }: SearchBarProps): React.JSX.Element {
  const { t } = useTranslation('common');

  return (
    <div className="px-3 py-2">
      <div className="relative">
        <Search className="absolute start-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
        <input
          aria-label={t('mainSelector.searchPlaceholder')}
          autoFocus
          className="flex h-8 w-full rounded-md border border-input bg-background ps-9 pe-8 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          onChange={(e) => onChange(e.target.value)}
          placeholder={t('mainSelector.searchPlaceholder')}
          value={value}
        />
        {value && (
          <button
            aria-label={t('mainSelector.clearSearch')}
            className="absolute end-2.5 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            onClick={() => onChange('')}
            type="button"
          >
            <X className="size-3.5" />
          </button>
        )}
      </div>
    </div>
  );
}
